module.exports = __webpack_public_path__ + "img/faro-rest.96e036d4.jpg";